const ShadowLightValues = Object.freeze({
    tint1: '0px 0px 16px 0px #00000024',
    tint2: '0px 0px 16px 0px #00000038',
    tint3: '0px 0px 16px 0px #00000061',
});
const ShadowDarkValues = Object.freeze({
    tint1: '0px 0px 16px 0px #00000024',
    tint2: '0px 0px 16px 0px #00000038',
    tint3: '0px 0px 16px 0px #00000061',
});
const Shadows = {
    tint1: 'var(--shadows-tint-1)',
    tint2: 'var(--shadows-tint-2)',
    tint3: 'var(--shadows-tint-3)',
};

export { ShadowDarkValues, ShadowLightValues, Shadows };
